module.exports = __webpack_public_path__ + "img/exam.b3aa8952.svg";